import { render, staticRenderFns } from "./DestinationsFeed.vue?vue&type=template&id=3d384811&"
import script from "./DestinationsFeed.vue?vue&type=script&lang=ts&"
export * from "./DestinationsFeed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports